import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EkskulSettingPage } from './ekskul-setting.page';

const routes: Routes = [
  {
    path: '',
    component: EkskulSettingPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EkskulSettingPage]
})
export class EkskulSettingPageModule {}
